import { jsx, jsxs } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { Fragment } from "react";
import { useSlotProps } from "../../../base/index.js";
import { CalendarDay } from "../CalendarDay/index.js";
import { useCalendarConfiguration } from "../context/CalendarRoot.js";
import { useDaysOfWeek, useHandleDayClick } from "../context/hooks/index.js";
import { calcMonthSize } from "../context/utils.js";
import { calendarMonthName, useCalendarMonthUtilityClasses } from "./classes.js";
import { Root } from "./components/Root.js";
import { WeeksContainer } from "./components/WeeksContainer.js";
function CalendarMonth(inProps) {
  const props = useThemeProps({
    name: calendarMonthName,
    props: inProps
  });
  const {
    days,
    testId = `${calendarMonthName}-root`,
    classes,
    onClick,
    className,
    renderDay = CalendarDay,
    components,
    componentsProps
  } = props;
  const config = useCalendarConfiguration();
  const {
    layout: { dayGapY },
    hideDaysOfWeek
  } = config;
  const showDaysOfWeek = !hideDaysOfWeek;
  const daysOfWeek = useDaysOfWeek();
  const { width, height } = calcMonthSize(config);
  const handleOnClick = useHandleDayClick(onClick);
  const ownerState = {
    testId,
    ...props
  };
  const utilityClasses = useCalendarMonthUtilityClasses({
    classes
  });
  const rootSlotProps = useSlotProps({
    className: [utilityClasses.root, className],
    ownerState,
    elementType: Root,
    additionalProps: {
      as: components?.Root,
      "data-testid": testId
    },
    externalSlotProps: componentsProps?.root
  });
  const weeksContainerSlotProps = useSlotProps({
    className: utilityClasses.weeksContainer,
    ownerState,
    elementType: WeeksContainer,
    externalSlotProps: componentsProps?.weeksContainer,
    additionalProps: {
      as: components?.WeeksContainer,
      dayGapY
    }
  });
  return /* @__PURE__ */ jsx(
    Root,
    {
      ...rootSlotProps,
      onClick: handleOnClick,
      monthWidth: width,
      monthHeight: height,
      onDoubleClick: handleOnClick,
      children: /* @__PURE__ */ jsxs(WeeksContainer, { ...weeksContainerSlotProps, children: [
        showDaysOfWeek && daysOfWeek.map((dayOfWeek, i) => /* @__PURE__ */ jsx(Fragment, { children: renderDay({
          day: {
            type: "dayOfWeek",
            label: dayOfWeek,
            firstOfRow: i === 0
          }
        }) }, i)),
        days.map((day, idx) => /* @__PURE__ */ jsx(Fragment, { children: renderDay({ day }) }, day.type === "day" ? day.id : idx))
      ] })
    }
  );
}
export {
  CalendarMonth
};
//# sourceMappingURL=CalendarMonth.js.map
